<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Affiliate Referral" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Referral</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <!-- <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row> -->

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table :items="referral_list" :fields="tablefields" per-page="perPage" :filter="filter" show-empty stacked="md">
                                    <template #cell(index)="data"> 
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(name)="row">
                                        <div v-if="row.item.name" style="max-width: 280px;">
                                            <h7>{{ row.item.name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(is_active)="row">
                                        <div v-if="row.item.is_active !== undefined" style="max-width: 280px;">
                                            <b-badge :variant="row.item.is_active ? 'primary' : 'danger'" style="font-size: 13px; max-width: fit-content;" @click="toggleReferral(row.item.id)" v-b-modal.modal-prevent-closing-toggle>
                                                {{ row.item.is_active ? 'Active' : 'Inactive' }}
                                            </b-badge>
                                        </div>
                                    </template>

                                    <template #cell(created_at)="row">
                                        <div v-if="row.item.created_at" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_at.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_at.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <!-- <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteReferral(data.item.id)" title="Delete"></feather>
                                            </div> -->

                                            <div @click="editReferral(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-between align-items-center" style="gap: 28px;">
                                <span style="display: flex; gap: 4px; min-width: fit-content;"> 
                                    <span>
                                        <!-- First Page Button (<<) -->
                                        <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                            <b-icon icon="chevron-double-left"></b-icon>
                                        </button>

                                        <!-- Previous Page Button (<) -->
                                        <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                            <b-icon icon="chevron-left"></b-icon>
                                        </button>
                                    </span>

                                    <!-- Page Number Display (Page X of Y) -->
                                    <span class="align-self-center">
                                        <span class="align-self-center">
                                            <span class="d-flex align-items-center" style="gap: 6px; padding: 0px 8px;">
                                                <span>Page</span>
                                                <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                                <span>of {{ totalPages }}</span>
                                            </span>
                                        </span>
                                    </span>

                                    <span>
                                        <!-- Next Page Button (>) -->
                                        <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                            <b-icon icon="chevron-right"></b-icon>
                                        </button>

                                        <!-- Last Page Button (>>) -->
                                        <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                            <b-icon icon="chevron-double-right"></b-icon>
                                        </button>
                                    </span>
                                </span>
                                <div style="min-width: 200px; display: flex; align-items: center;">
                                    <span style="width: 160px;">Per page:</span> <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div> 
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Referral Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Referral" size="md" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Affiliate Name</label>
                        <input class="form-control" type="text" placeholder="Enter affiliate name" v-model="referral.name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Referral Code</label>
                        <input class="form-control" type="text" placeholder="Enter referral code" v-model="referral.code">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Reward Coins</label>
                        <input class="form-control" type="number" placeholder="Enter reward coins" v-model="referral.new_user_reward_coins">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Referral Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Referral" size="md" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Affiliate Name</label>
                        <input class="form-control" type="text" placeholder="Enter affiliate name" v-model="edit_referral.name">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Referral Code</label>
                        <input class="form-control" type="text" placeholder="Enter referral code" v-model="edit_referral.code">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Reward Coins</label>
                        <input class="form-control" type="number" placeholder="Enter reward coins" v-model="edit_referral.new_user_reward_coins">
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Referral Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this referral?</div>
    </b-modal>

    <!-- Referral Toggle Modal -->
    <b-modal id="modal-prevent-closing-toggle" centered hide-header @ok="handleToggleOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to update referral status?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Affiliate Name',
                    sortable: true
                },
                {
                    key: 'code',
                    label: 'Referral Code',
                    sortable: true
                },
                {
                    key: 'new_user_reward_coins',
                    label: 'Reward Coins',
                    sortable: true
                },
                {
                    key: 'is_active',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'created_at',
                    label: 'Created At',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            referral: {
                name: "",
                code: "",
                new_user_reward_coins: ""
            },
            edit_referral: {
                id: null,
                name: "",
                code: "",
                new_user_reward_coins: ""
            },
            delete_value: null,
            toggle_id: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            initialLoad: true,
            loadingPage: false,
            pageOptions: [20, 30, 50]
        };
    },

    computed: {
        ...mapState({
            referral_list: state => state.referral.referral,
            count: state => state.referral.referralCount,
            loading: state => state.referral.referralLoading,
            error: state => state.referral.referralError
        }),

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

     watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                
                this.$router.replace({
                    path: '/system/affiliate-referral',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                
                this.currentPage = newCurrentPage
                this.$store.dispatch("referral/fetchReferral", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                
                this.$router.replace({
                    path: '/system/affiliate-referral',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("referral/fetchReferral", {
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    mounted() { 
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        fetchInitial() {
            this.$store.dispatch("referral/fetchReferral", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

        resetModal() {
            this.referral.name = ""
            this.referral.code = ""
            this.referral.new_user_reward_coins = ""
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("referral/addReferral", {
                referral: this.referral
            }).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                   this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editReferral(detail) {
            this.edit_referral.id = detail.id ? detail.id : null
            this.edit_referral.name = detail.name ? detail.name : null
            this.edit_referral.code = detail.code ? detail.code : null
            this.edit_referral.new_user_reward_coins = detail.new_user_reward_coins ? detail.new_user_reward_coins : null
        },

        resetEditModal() {
            this.edit_referral.name = null
            this.edit_referral.code = null
            this.edit_referral.new_user_reward_coins = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("referral/updateReferral", {
                id: this.edit_referral.id,
                referral: this.edit_referral,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        toggleReferral(referral) {
            this.toggle_id = referral
        },

        handleToggleOk() {
            this.$store.dispatch("referral/updateReferralStatus", {
                toggle_id: this.toggle_id,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.toggle_id = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        // deleteReferral(id) {
        //     this.delete_value = id
        // },

        // handleDeleteOk() {
        //     this.$store.dispatch("referral/deleteReferral", {
        //         delete: this.delete_value,
        //         perPage: this.$route.query.perPage,
        //         currentPage: this.$route.query.page
        //     }).then(response => {
        //         if (response.code == 200) {
        //             Swal.fire({
        //                 title: "Success!",
        //                 text: response.response,
        //                 icon: "success"
        //             });
        //             this.delete_value = null
        //         } else {
        //             Swal.fire({
        //                 title: "Error!",
        //                 text: response.response,
        //                 icon: "error"
        //             });
        //         }
        //     })
        // }
    }
};
</script>
